module.exports = __webpack_public_path__ + "img/Twitter.e9489672.svg";